module.exports = {
      id: "ic-ethusd-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-ad374a.smartcharts.svg#ic-ethusd-usage",
      toString: function () {
        return this.url;
      }
    }